<template>
  <div class="watch-page">
    <NavBar active-page="watch" />
    
    <div class="content">
      <div class="video-container">
        <h2 class="video-title">示范课: 第一册 《治国之道》 - 第一课 王者风范</h2>
        
        <div class="video-player">
          <!-- 这里使用一个简单的视频播放器占位符 -->
          <div class="video-placeholder">
            <div class="play-button">▶</div>
            <p>点击播放示范课</p>
          </div>
        </div>
        
        <div class="video-description">
          <h3>课程简介</h3>
          <p>本课程将介绍王者之道的核心理念，探讨古代帝王治国的智慧与方略。通过对历史典籍的解读，了解传统文化中的治国智慧，以及如何将这些智慧应用到现代管理与生活中。</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { useRouter } from 'vue-router'
import NavBar from '@/components/NavBar.vue'

export default {
  name: 'WatchPage',
  components: {
    NavBar
  },
  setup() {
    const router = useRouter()
    
    const navigateToListen = () => {
      router.push('/listen')
    }
    
    const navigateToLogin = () => {
      router.push('/login')
    }
    
    const navigateToRegister = () => {
      router.push('/register')
    }
    
    const navigateToAbout = () => {
      router.push('/about')
    }
    
    return {
      navigateToListen,
      navigateToLogin,
      navigateToRegister,
      navigateToAbout
    }
  },
  computed: {
    ...mapGetters(['isAuthenticated', 'currentUser'])
  },
  methods: {
    handleLogout() {
      this.$store.commit('logout')
    }
  },
  mounted() {
    this.$store.dispatch('checkAuth')
  }
}
</script>

<style scoped>
.watch-page {
  width: 100%;
  height: 100vh;
  display: flex;
  flex-direction: column;
  background-color: #fff;
}

.nav-bar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 24px;
  border-bottom: 1px solid #eee;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
}

.nav-items {
  display: flex;
  gap: 40px;
}

.nav-item {
  font-size: 20px;
  font-weight: 500;
  cursor: pointer;
  padding: 4px 8px;
  position: relative;
}

.nav-item.active {
  font-weight: bold;
}

.nav-item.active::after {
  content: '';
  position: absolute;
  bottom: -2px;
  left: 0;
  width: 100%;
  height: 2px;
  background-color: #000;
}

.auth-buttons {
  display: flex;
  gap: 20px;
}

.auth-button {
  cursor: pointer;
  font-size: 16px;
}

.content {
  flex: 1;
  padding: 24px;
  overflow-y: auto;
}

.video-container {
  max-width: 800px;
  margin: 0 auto;
  width: 100%;
}

.video-title {
  font-size: 24px;
  margin-bottom: 20px;
  text-align: center;
}

.video-player {
  aspect-ratio: 16 / 9;
  background-color: #000;
  border-radius: 8px;
  overflow: hidden;
  margin-bottom: 30px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.video-placeholder {
  display: flex;
  flex-direction: column;
  align-items: center;
  color: white;
  cursor: pointer;
}

.play-button {
  width: 70px;
  height: 70px;
  background-color: rgba(255, 255, 255, 0.2);
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 30px;
  margin-bottom: 10px;
}

.video-description {
  padding: 20px;
  background-color: #f9f9f9;
  border-radius: 8px;
}

.video-description h3 {
  margin-bottom: 10px;
  font-size: 18px;
}

.video-description p {
  line-height: 1.6;
  color: #555;
}
</style> 